<template>
  <svg
    id="Inativar_Orgão"
    data-name="Inativar Orgão"
    xmlns="http://www.w3.org/2000/svg"
    :width="width"
    :height="height ? height : width"
    viewBox="0 0 213 204.297"
  >
    <g
      id="Retângulo_10"
      data-name="Retângulo 10"
      transform="translate(0 28.297)"
      fill="none"
      :stroke="color"
      stroke-linecap="round"
      stroke-linejoin="round"
      stroke-width="15"
    >
      <rect width="182" height="176" rx="35" stroke="none" />
      <rect x="7.5" y="7.5" width="167" height="161" rx="27.5" fill="none" />
    </g>
    <path
      id="Caminho_4"
      data-name="Caminho 4"
      d="M0-12H169.377l-7.794,117.077H0Z"
      transform="translate(82.748 169.377) rotate(-90)"
      fill="#fff"
    />
    <path
      id="Icon_awesome-building"
      data-name="Icon awesome-building"
      d="M125.18,137.813h-5.742V6.891A6.891,6.891,0,0,0,112.547,0H16.078A6.891,6.891,0,0,0,9.188,6.891V137.813H3.445A3.445,3.445,0,0,0,0,141.258V147H128.625v-5.742A3.445,3.445,0,0,0,125.18,137.813ZM36.75,21.82A3.445,3.445,0,0,1,40.2,18.375H51.68a3.445,3.445,0,0,1,3.445,3.445V33.3A3.445,3.445,0,0,1,51.68,36.75H40.2A3.445,3.445,0,0,1,36.75,33.3Zm0,27.563A3.445,3.445,0,0,1,40.2,45.938H51.68a3.445,3.445,0,0,1,3.445,3.445V60.867a3.445,3.445,0,0,1-3.445,3.445H40.2a3.445,3.445,0,0,1-3.445-3.445ZM51.68,91.875H40.2A3.445,3.445,0,0,1,36.75,88.43V76.945A3.445,3.445,0,0,1,40.2,73.5H51.68a3.445,3.445,0,0,1,3.445,3.445V88.43A3.445,3.445,0,0,1,51.68,91.875ZM73.5,137.813H55.125V113.7a3.445,3.445,0,0,1,3.445-3.445H70.055A3.445,3.445,0,0,1,73.5,113.7ZM91.875,88.43a3.445,3.445,0,0,1-3.445,3.445H76.945A3.445,3.445,0,0,1,73.5,88.43V76.945A3.445,3.445,0,0,1,76.945,73.5H88.43a3.445,3.445,0,0,1,3.445,3.445Zm0-27.562a3.445,3.445,0,0,1-3.445,3.445H76.945A3.445,3.445,0,0,1,73.5,60.867V49.383a3.445,3.445,0,0,1,3.445-3.445H88.43a3.445,3.445,0,0,1,3.445,3.445Zm0-27.562A3.445,3.445,0,0,1,88.43,36.75H76.945A3.445,3.445,0,0,1,73.5,33.3V21.82a3.445,3.445,0,0,1,3.445-3.445H88.43a3.445,3.445,0,0,1,3.445,3.445Z"
      transform="translate(71 11.297)"
      :fill="color"
    />
    <ellipse
      id="Elipse_1"
      data-name="Elipse 1"
      cx="39"
      cy="39.5"
      rx="39"
      ry="39.5"
      transform="translate(135 90.297)"
      fill="#fff"
    />
    <g
      id="Icon_ionic-ios-close-circle-outline"
      data-name="Icon ionic-ios-close-circle-outline"
      transform="translate(134.625 90.922)"
    >
      <path
        id="Caminho_5"
        data-name="Caminho 5"
        d="M39,35.133,29.97,26.107,39,17.08a2.737,2.737,0,0,0-3.871-3.871L26.1,22.236,17.073,13.21a2.619,2.619,0,0,0-3.871,0,2.645,2.645,0,0,0,0,3.871l9.026,9.026L13.2,35.133A2.646,2.646,0,0,0,13.2,39a2.719,2.719,0,0,0,3.871,0L26.1,29.977,35.125,39A2.75,2.75,0,0,0,39,39,2.719,2.719,0,0,0,39,35.133Z"
        transform="translate(12.901 12.893)"
        :fill="color"
      />
      <path
        id="Caminho_6"
        data-name="Caminho 6"
        d="M39,8.171A30.834,30.834,0,0,1,60.8,60.8,30.834,30.834,0,0,1,17.2,17.2,30.625,30.625,0,0,1,39,8.171m0-4.8A35.625,35.625,0,1,0,74.625,39,35.62,35.62,0,0,0,39,3.375Z"
        transform="translate(0 0)"
        :fill="color"
      />
    </g>
  </svg>
</template>

<script>
export default {
  props: {
    width: { required: false, type: String, default: '100%' },
    height: { required: false, type: String },
    color: { required: false, type: String, default: '#4e73df' }
  }
}
</script>
